// src/pages/SkillsPage.tsx - Full version
import React, { useState, useEffect } from 'react';
import { getSkills, Skill } from '../api/skillService';
import './SkillsPage.css'; // Create this file for styling

const SkillsPage: React.FC = () => {
  const [skills, setSkills] = useState<Skill[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const data = await getSkills();
        setSkills(data);
      } catch (err: any) {
        console.error('Error fetching skills:', err);
        setError(`Failed to load skills: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchSkills();
  }, []);

  // Group skills by category
  const skillsByCategory = skills.reduce((acc, skill) => {
    if (!acc[skill.category]) {
      acc[skill.category] = [];
    }
    acc[skill.category].push(skill);
    return acc;
  }, {} as Record<string, Skill[]>);

  if (loading) return <div className="skills-container"><p>Loading skills...</p></div>;
  if (error) return <div className="skills-container"><p className="error">{error}</p></div>;

  return (
    <div className="skills-container">
      <h1>Skills</h1>
      
      {Object.entries(skillsByCategory).map(([category, categorySkills]) => (
        <div key={category} className="skill-category">
          <h2>{category}</h2>
          <div className="skills-list">
            {categorySkills.map(skill => (
              <div key={skill.id} className="skill-item">
                <div className="skill-header">
                  <h3>{skill.name}</h3>
                  <span className="skill-proficiency">{skill.proficiency}%</span>
                </div>
                <div className="skill-bar">
                  <div 
                    className="skill-progress" 
                    style={{ width: `${skill.proficiency}%` }}
                  ></div>
                </div>
                {skill.description && (
                  <p className="skill-description">{skill.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkillsPage;
